import { render, staticRenderFns } from "./MAM_transferTerminalBack.vue?vue&type=template&id=3cdb320e&scoped=true&"
import script from "./MAM_transferTerminalBack.vue?vue&type=script&lang=js&"
export * from "./MAM_transferTerminalBack.vue?vue&type=script&lang=js&"
import style0 from "./MAM_transferTerminalBack.vue?vue&type=style&index=0&id=3cdb320e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdb320e",
  null
  
)

export default component.exports